var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 17.8391C13.3144 17.8391 13.1285 17.7772 13.0046 17.6223L6.00354 10.4973C5.72473 10.2185 5.72473 9.78478 6.00354 9.50598L13.0046 2.38098C13.2834 2.10217 13.7171 2.10217 13.9959 2.38098C14.2747 2.65978 14.2747 3.09348 13.9959 3.37228L7.49049 10.0016L14.0269 16.631C14.3057 16.9098 14.3057 17.3435 14.0269 17.6223C13.841 17.7462 13.6861 17.8391 13.5003 17.8391Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.3daa7d1869fd540fd808bd83a188f8be.svg";
export { ForwardRef as ReactComponent };